import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class UpdateSupplierInvoiceLineDto {
  @Expose()
  concept?: string;

  @Expose()
  quantity?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  unitPrice?: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  totalPrice?: number;
}
